import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const Tooltipchisquare = () => (
  <Tooltip title=" Data type - string, Object and Date are not allowed">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default Tooltipchisquare;